import React from 'react'
import {Redirect, Route} from 'react-router-dom'
import PropTypes from 'prop-types'
import {isAuthenticated} from "../../services/utils";

export const PrivateRoute = (props) => {
  const { layout: Layout, component: Component, image, ...rest } = props;

  const validateDataCurrentUser = () => {
        const data = isAuthenticated();
        if (!data) {
            return false;
        }
        //TODO save data decode JWT
        return true;
  }

  return validateDataCurrentUser() ? (
    <Route
      {...rest}
      render={(matchProps) => (
        <Layout image={image}>
          <Component {...matchProps} />
        </Layout>
      )}
    />
  ) : (<Redirect to="/register-account" />)
}

PrivateRoute.propTypes = {
  component: PropTypes.any.isRequired,
  layout: PropTypes.any.isRequired,
  path: PropTypes.string,
  image : PropTypes.string,
}
